import { render, staticRenderFns } from "./TheAlertNotice.vue?vue&type=template&id=46c0b768"
import script from "./TheAlertNotice.vue?vue&type=script&lang=js"
export * from "./TheAlertNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports